import { SvgConsentOneATwoA, SvgConsentOne, SvgConsentIntro, SvgConsentOneB, SvgConsentOneBEnd} from "components/Images/consent";

const consentOne = [
    {
        id: 'consent-1',
        type: 'question',
        text: "<p>After some time has passed Alex and Sam’s dancing becomes closer. They smile at each other, and their faces start to draw closer and…</p><p>How does the night proceed?</p>",
        backgroundImage: SvgConsentOne,
        options: [
          {
            id: 'consent-1-option-1',
            text: 'Alex and Sam kiss. Smiling, Sam asks do you want to go somewhere more private? Alex nods and they head to the bedroom.',
            icon: '💋',
            iconBackground: '#ffdaf7',
            nextStepId: 'consent-1-learnmore'
          },
          {
            id: 'consent-1-option-2',
            text: 'Alex asks Sam if they want a beer. Sam agrees. They grab a couple from the esky and then head out to the porch.',
            icon: '🍻',
            iconBackground:'#faf4bb',
            nextStepId: 'consent-2-learnmore',
  
          },
          {
            id: 'consent-1-option-3',
            text: 'Alex and Sam kiss, and Alex’s hands gradually move from Sam’s back to Sam’s butt. Sam starts to pull away.',
            icon: '🍑',
            iconBackground:'#fdccb2',
            nextStepId: 'consent-3-learnmore',
            
          }
        ]
      },
      {
        id: 'consent-1-learnmore',
        type: 'learnmore',
        text: '<p>Both Alex and Sam appear to consent to kissing through body language (smiling, leaning in closer, etc.).</p><p>By agreeing to go somewhere more private, they are consenting through words and body language that they\'d like to move to a more private setting.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOne,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>An enthusiastic ‘YES’ is essential when it comes to any sexual activity, including kissing, whether with a longer-term partner or hooking up with a new one.</p><p>Non-verbal cues (i.e., body language) can be a good indication of what your partner might be feeling.  Non-verbal consent can be actively touching, kissing, hugging or responding to touch and pulling someone closer to you. In this instance, the look on their faces and their body language show that they both consent to kissing.</p><p>Asking questions, like “do you like that?” or “do you want to go somewhere more private?” and getting a verbal ‘YES’ ensures you are on the same page.</p>"
        },
        nextStepId: 'consent-1a',
      },
      {
        id: 'consent-1a',
        type: 'question',
        text: "<p>After a few minutes of making out, Sam moves to unzip Alex’s pants.</p><p>How does the night proceed?</p>",
        backgroundImage:  SvgConsentOneATwoA,
        options: [
          {
            id: 'consent-1a-option-1',
            text: 'Alex is into it. Asking Sam if they are sure, Alex starts to move a hand up Sam’s shirt. Sam nods yes, and then pulls out a condom as they start to undress. ',
            icon: '😍',
            iconBackground: '#fededd',
            nextStepId: 'consent-1a-learnmore'
          },
          {
            id: 'consent-1-option-2',
            text: 'Alex puts their hand on Sam’s to stop them unzipping their pants and says “we’re moving a bit fast. Can we go back to kissing? I am really enjoying that.”',
            icon: '💬',
            iconBackground:'#cbd8f9',
            nextStepId: 'consent-1b-learnmore',
  
          }
        ]
      },
      {
        id: 'consent-1a-learnmore',
        type: 'learnmore',
        text: '<p>Both Alex and Sam seem comfortable moving forward, both indicating they are into having sex through verbal and non-verbal cues. </p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneATwoA,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Consent is an agreement by each person to engage in a sexual activity. Consent should be enthusiastic, and clearly and freely communicated. Expressing consent can help both you and your partner to understand and respect each other’s boundaries. </p><p>When it comes to sexual activity, consent is really important. Remember that you have a responsibility to each other to make sure that you feel safe and comfortable every step along the way. Your actions towards the person you’re with can greatly affect the way they feel about you, themselves, the relationship, and sex in general.</p>"
        },
        nextStepId: 'consent-1a-1-2',
      },
      {
        id: 'consent-1a-1-2',
        type: 'question',
        text: "<p>After a bit of foreplay, Alex checks in again whether Sam is still up for sex.</p><p>How does the night proceed?</p>",
        backgroundImage:  SvgConsentOneATwoA,
        options: [
          {
            id: 'consent-1a-option-1',
            text: 'Sam nods, they cuddle, and start to have sex.',
            icon: '💓',
            iconBackground: '#fededd',
            nextStepId: 'consent-1a-1-end'
          },
          {
            id: 'consent-1-option-2',
            text: 'Sam has second thoughts and changes their mind, asking Alex to stop. Alex stops, and they go back to the party.',
            icon: '😐',
            iconBackground:'#fbe9b6',
            nextStepId: 'consent-1a-2-end',
  
          }
        ]
      },
      {
        id: 'consent-1a-1-end',
        type: 'learnmore',
        text: '<p>Sam and Alex both have agreed to have sex, giving active, and enthusiastic consent to continue</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneATwoA,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>It’s important that you are sure that the person you’re with is happy and comfortable because non-consensual sexual activity (anything from touching and kissing to penetration) is against the law.</p><p>The best way to ensure that everyone involved is comfortable with any sexual activity is to talk about it, check in periodically, and make sure everyone involved consents before escalating or changing activities. For more information about consent, <a href='https://bodytalk.org.au/relationships/relationships-consent/' target='_blank'>click here.</a></p>"
        },
        nextStepId: null,
      },
      {
        id: 'consent-1a-2-end',
        type: 'learnmore',
        text: "<p>Everyone has the right to say 'no' and to change their mind at any time, even if they’ve taken their clothes off or even if they’ve started to have sex. </p><p>Anyone can withdraw consent at any point. The best way to do this is to clearly communicate to your partner that you are no longer comfortable and wish to stop. </p>",
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentIntro,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>It’s important that you are sure that the person you’re with is happy and comfortable because non-consensual sexual activity (anything from touching and kissing to penetration) is against the law.</p><p>The best way to ensure that everyone involved is comfortable with any sexual activity is to talk about it, check in periodically, and make sure everyone involved consents before escalating or changing activities. For more information about consent, <a href='https://bodytalk.org.au/relationships/relationships-consent/' target='_blank'>click here.</a></p>"
        },
        nextStepId: null,
      },
      {
        id: 'consent-1b-learnmore',
        type: 'learnmore',
        text: 'Alex has communicated that they are not sure whether they are ready to go further and would like to pause and chat about it. Remember everyone has the right to say ‘NO’.</p><p>If one person feels uncomfortable or isn’t sure, it’s ok to let the other person know. Just because someone consents to making out, doesn’t mean a person is ready to go further.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneB,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>Proceeding with any sexual activity without consent is an offence. It’s against the law to do sexual things (even kissing or touching) without consent. This is called sexual assault and it’s a crime. Not only it is a crime, but also the emotional consequences of sexual assault can last a lifetime.</p><p>If you’re unsure whether someone is consenting, ask. </p><p>For more information about sexual assault, visit the <a href='https://au.reachout.com/articles/sexual-assault' target='_blank'>Reachout website</a></p>"
        },
        nextStepId: 'consent-1b-1-2',
      },
      {
        id: 'consent-1b-1-2',
        type: 'question',
        text: "<p>Alex says “I’m sorry but I don’t think I’m ready to go any further. I’m keen to get to know you better. You want to go grab a bite to eat?”</p><p>How does the night proceed?</p>",
        backgroundImage:  SvgConsentOneB,
        options: [
          {
            id: 'consent-1b-1-2-option-1',
            text: 'Sam keeps kissing Alex and trying to unzip their pants.',
            icon: '👖',
            iconBackground: '#c5d2ff',
            nextStepId: 'consent-1b-1-end'
          },
          {
            id: 'consent-1b-1-2-option-2',
            text: 'Sam stops, they grab their stuff and go back to the party to let their friends know they are heading out.',
            icon: '🙂',
            iconBackground:'#fbe9b6',
            nextStepId: 'consent-1b-2-end',
  
          }
        ]
      },
      {
        id: 'consent-1b-1-end',
        type: 'learnmore',
        text: '<p>Proceeding with any sexual activity without consent is an offence. Alex can again tell Sam to stop, that they are making them uncomfortable and move away. </p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneB,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>It's important that we make sure that the person we're with is happy and comfortable because non-consensual sexual activity (anything from touching and kissing to penetration) is against the law.</p><p>If someone does something to make you feel uncomfortable or you feel that you have experienced sexual assault, move to somewhere safe, talk a trusted friend or family member, and/or call a support service. </p>"
        },
        nextStepId: null,
      },
      {
        id: 'consent-1b-2-end',
        type: 'learnmore',
        text: '<p>There’s really no reason to rush into sex if you aren’t feeling it. Taking the time to get to know each other, making sure you are both comfortable and talking about how far you want things to go can make the time they spend together a lot more satisfying and enjoyable for all involved.</p>',
        scrollText: "<span>Scroll down</span> to learn more.",
        backgroundImage: SvgConsentOneBEnd,
        learnmore: {
          title: "More about consent 🤔",
          content: "<p>If you feel that things are moving along a bit too quickly, here are some things you can say to let your partner know:</p><p>“I’m really enjoying making out with you! I don’t think I’m ready to go any further just yet.”<br>“Can we stay like this for a while?”<br>“Can we slow down a bit?”</p>"
        },
        nextStepId: null,
      }

]

export default consentOne